import React from 'react';
import Icon from './AppIcon';
import { useGoogleAnalytics } from '../hooks/useGoogleAnalytics';

const BookingModal = ({ isOpen, onClose }) => {
  const { trackEvent } = useGoogleAnalytics();

  if (!isOpen) return null;

  const handleClose = () => {
    trackEvent('booking_modal_toggle', {
      action: 'close',
      location: 'modal'
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/55 p-2 sm:p-4 backdrop-blur-sm">
      <div className="w-full max-w-4xl max-h-[90vh] overflow-hidden rounded-2xl border border-border bg-card shadow-2xl flex flex-col">
        <div className="flex items-center justify-between border-b border-border px-4 sm:px-6 py-3 sm:py-4 flex-shrink-0">
          <div className="min-w-0 flex-1">
            <p className="text-xs uppercase tracking-wide text-text-secondary hidden sm:block">Start your engagement</p>
            <h3 className="text-base sm:text-lg font-semibold text-text-primary truncate">Schedule Your GCC Strategy Session</h3>
          </div>
          <button
            onClick={handleClose}
            className="rounded-lg p-2 text-text-secondary transition-colors hover:bg-muted/60 hover:text-primary flex-shrink-0"
            aria-label="Close booking modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>
        <div className="p-4 sm:p-6 overflow-y-auto flex-1">
          <div className="text-center mb-4 sm:mb-6">
            <h3 className="font-headline font-headline-bold text-xl sm:text-2xl lg:text-3xl text-text-primary mb-2">
              Book a Call
            </h3>
            <p className="font-body text-text-secondary text-sm sm:text-base">
              Schedule your consultation directly with our team
            </p>
          </div>
          <div className="relative bg-card border border-border rounded-xl overflow-hidden shadow-executive" style={{ minHeight: '500px' }}>
            <iframe 
              src="https://outlook.office.com/book/GCCConsulting1@bootminds.com/?ismsaljsauthenabled" 
              width="100%" 
              height="500" 
              scrolling="yes" 
              style={{ border: 0, minHeight: '500px' }}
              title="Book a consultation"
              className="relative z-10 bg-background w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
